<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">车船基本信息管理</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="设备名称" prop="CarName">
            <el-input v-model="CarName" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label="设备类型">
            <el-select v-model="DeviceType" placeholder="请选择">
              <el-option
                v-for="item in DeviceTypeArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="CarName"
                label="设备名称"
              ></el-table-column>
              <el-table-column prop="DeviceType" label="设备类型">
                <template slot-scope="scope">
                  <span v-if="scope.row.DeviceType == '1'">车辆</span>
                  <span v-else-if="scope.row.DeviceType == '2'">游船</span>
                </template>
              </el-table-column>
              <el-table-column prop="PlateNo" label="车牌号"></el-table-column>
              <el-table-column prop="SimNo" label="SIM卡号"></el-table-column>
              <el-table-column
                prop="Contactor"
                label="负责人"
              ></el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="queryDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >查看</el-button
                    >
                    <el-button
                      @click="editDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >编辑</el-button
                    >
                    <el-button
                      @click="deleteClick(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >删除</el-button
                    >
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";
export default {
  name: "CarShipManagerView",
  controller: "UI",
  action: "CarShipManagerView",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      CarName: "",
      DeviceType: "",
      DeviceTypeArr: [
        { value: "", label: "全部" },
        { value: "1", label: "车辆" },
        { value: "2", label: "游船" },
      ],
    };
  },
  mounted: function() {
    this.search();
    this.logInfo.ActionName = "车船基本信息查询";
    this.logInfo.LogMessage = "车船基本信息查询";
    this.logInfo.ModuleName = "车辆调度";
    this.logInfo.PageName = "车船基本信息列表";
    this.addOperationLog();
  },
  methods: {
    search() {
      let searchInfo = {
        CarName: this.CarName,
        DeviceType: this.DeviceType,
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };
      new MyApis.TranResourcesApi()
        .GetItemPagingList(searchInfo)
        .then((r) => {
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/vehicleScheduling/UI/CarShipManagerInfo",
        query: {
          type: "add",
        },
      });
    },
    //查看
    queryDetail(index, row) {
      this.$router.push({
        path: "/plugin/vehicleScheduling/ui/CarShipManagerInfo",
        query: { InfoId: row.ID, type: "query" },
      });
    },
    //编辑
    editDetail(index, row) {
      this.$router.push({
        path: "/plugin/vehicleScheduling/ui/CarShipManagerInfo",
        query: { InfoId: row.ID, type: "edit" },
      });
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          new MyApis.TranResourcesApi()
            .DelItem(row)
            .then((r) => {
              r = r.data.Data;
              if (r) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.logInfo.ActionName = "车船基本信息删除";
                this.logInfo.LogMessage = "车船基本信息删除";
                this.logInfo.ModuleName = "车辆调度";
                this.logInfo.PageName = "车船基本信息列表";
                this.addOperationLog();
              } else {
                this.$message({
                  type: "error",
                  message: "删除失败!",
                });
              }
              this.search();
            })
            .catch((e) => {
              console.log(e);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.CarName = "";
      this.DeviceType = "";
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
  },
};
</script>
